// src/App.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoadingOverlay from "./features/ui/LoadingOverlay";
import LoginPage from "./pages/LoginPage";
import CallbackPage from "./pages/CallbackPage";
import HomePage, { DEFAULT_TAB_PATH } from "./pages/HomePage";
import WorksheetDetailPage from "./pages/WorksheetDetailPage";
import { authService } from "./services/authService";
import { fetchUserInfo } from "./features/auth/authSlice";
import AttendanceKioskPage from "./pages/AttendanceKioskPage";

// 첫 진입 주소. 로그인한 사람은 기본 메뉴로 보내고, 아니면 로그인(지인에듀 OAuth)으로 보낸다.
const RootRoute = () =>
  authService.isAuthenticated() ? (
    <Navigate to={DEFAULT_TAB_PATH} replace />
  ) : (
    <LoginPage />
  );

function App() {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);

  // 로그인한 계정 정보는 어느 화면에서든 필요하다(상단 바, 관리자 메뉴 노출, 플랜 확인).
  // 화면마다 부르면 부르지 않는 화면에서 비어 있게 되므로 앱에서 한 번만 받는다.
  // Django 의 context processor 자리에 해당한다.
  //
  // isLoggedIn 을 함께 보는 이유: 최초 로그인 때는 앱이 뜨는 시점에 아직 토큰이 없다
  // (/callback 이 코드를 검증하기 전이다). 콜백이 토큰을 저장하며 loginSuccess 를
  // 보내면 이 값이 바뀌고, 그때 다시 받아온다. 이것이 없으면 로그인 직후 상단 바에
  // 이름이 비어 대체 문구가 보인다.
  useEffect(() => {
    if (authService.isAuthenticated()) {
      dispatch(fetchUserInfo());
    }
  }, [dispatch, isLoggedIn]);

  return (
    <Router>
      <LoadingOverlay>
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          {/* 학원 태블릿용 출결 화면. 메뉴 없이 화면 가득 쓴다 */}
          <Route path="/attendance" element={<AttendanceKioskPage />} />
          <Route
            path="/worksheet/:type/:id"
            element={<WorksheetDetailPage />}
          />
          {/* 메뉴가 곧 주소다. 새로고침하거나 링크를 공유해도 보던 화면이 그대로 열린다.
              하위 메뉴가 없는 메뉴는 /<메뉴> 한 단계로 끝난다.
              위의 고정 경로들이 먼저 잡히고(react-router 는 정적 구간을 우선한다),
              세 칸짜리 /worksheet/:type/:id 도 두 칸짜리 아래 규칙과 겹치지 않는다. */}
          <Route path="/:topTab" element={<HomePage />} />
          <Route path="/:topTab/:subTab" element={<HomePage />} />
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </LoadingOverlay>
    </Router>
  );
}

export default App;
